import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from 'src/app/data.service';
import { LanguageService } from 'src/app/language.service';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { ErrorCodeEntry } from 'src/app/shared/services/errorcode-translation.service';
import { RouteHistoryService } from 'src/app/shared/services/router-history.service';
import { PlayerErrorService } from './player-error.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-player-error',
  templateUrl: './player-error.component.html',
  styleUrls: ['./player-error.component.scss'],
})
export class PlayerErrorComponent implements OnInit, OnDestroy {
  @Input() errorCode: string;

  error: ErrorCodeEntry;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogService: DialogService,
    private playerErrorService: PlayerErrorService,
    private readonly languageService: LanguageService,
    private readonly dataService: DataService,
    private readonly routerHistoryService: RouteHistoryService,
    private readonly router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    this.dataService.disablePlayerListener = true;
    if (this.data.errorCode) {
      this.errorCode = this.data.errorCode;
    }
    if (!this.errorCode) {
      throw new Error('Error code is required for PlayerErrorComponent');
    }

    this.playerErrorService.getErrorMessage(this.errorCode).then((error) => {
      this.error = error;
    });
  }

  getLocalizedMessage(): string {
    if (this.data?.message) {
      return this.data.message;
    }
    if (!this.error) {
      return ''; // or some default message
    }
    return this.playerErrorService.getLocalizedMessage(this.error);
  }

  getButtonLabel(): string {
    return this.data?.buttonLabel || 'global.cancel';
  }

  getErrorCode(): string {
    if (!this.error) {
      return ''; // or some default message
    }
    return this.languageService.getTranslatedTextWithParams(
      'global.error_code',
      [this.error.errorCode]
    );
  }

  async goBack() {
    this.dialogService.closeAll();
    if (this.data?.redirectPath) {
      if (this.data?.forceLogout) {
        this.dataService.isLoggingOut = false;
      }
      this.router.navigate([this.data.redirectPath]);
      return;
    }
    if (this.dataService.isFromDeeplink && this.data?.currentResource) {
      const detailUrl = `/${this.data.currentResource.contentType}/${this.data.currentResource.id}`;
      this.router.navigate([detailUrl]);
      return;
    }
    this.routerHistoryService.goBack();
  }

  ngOnDestroy(): void {
    this.dataService.disablePlayerListener = false;
  }

  disabled(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }

  handleKeydown(event: KeyboardEvent) {
    if (event.isUp() || event.isDown()) {
      this.disabled(event);
    }
  }
}
